import { render, staticRenderFns } from "./CampoFicheroMultiple.vue?vue&type=template&id=01fbaf0e"
import script from "./CampoFicheroMultiple.vue?vue&type=script&lang=js"
export * from "./CampoFicheroMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports